import {
  EMPRESA_PATH,
  PROYECTO_PATH,
  ELEMENTO_PATH,
  USUARIO_PATH,
  SENSOR_PATH,
  TARJETA_PATH,
  GRAFICA_PATH,
} from '../routes/path';

export const routeEmpresa = [
  {
    text: 'Empresas'
  }
];

export const routeEmpresaInfo = [
  {
    route: EMPRESA_PATH,
    text: 'Empresas',
  },
  {
    text: 'Info Empresa',
  },
];
export const routeProyecto = [
  {
    text: 'Proyectos'
  }
];
export const routeProyectoInfo = [
  {
    route: PROYECTO_PATH,
    text: 'Proyectos'
  },
  {
    text: 'Info Proyecto',
  },
];

export const routeElemento = [
  {
    text: 'Elementos'
  }
];

export const routeElementoInfo = [
  {
    route: ELEMENTO_PATH,
    text: 'Elementos',
  },
  {
    text: 'Info Elemento'
  }
];

export const routeUsuario = [
  {
    text: 'Usuarios',
  },
];

export const routeUsuarioInfo = [
  {
    route: USUARIO_PATH,
    text: 'Usuarios',
  },
  {
    text: 'Info Usuario',
  },
];

export const routePrivilegiosUsuario = [
  {
    route: USUARIO_PATH,
    text: 'Usuarios',
  },
  {
    text: 'Info Usuario',
  },
  {
    text: 'Privilegios',
  },
];

export const routeTarjeta = [
  {
    text: 'Tarjetas',
  },
];

export const routeTarjetaInfo = [
  {
    route: TARJETA_PATH,
    text: 'Tarjetas',
  },
  {
    text: 'Info Tarjeta',
  },
];

export const routeTarjetaEdit = (nombre) => [
  {
    route: TARJETA_PATH,
    text: 'Tarjetas',
  },
  {
    text: `Editar: ${nombre}`,
  },
];

export const routeSensor = [
  {
    text: 'Sensores',
  },
];

export const routeSensorInfo = [
  {
    route: SENSOR_PATH,
    text: 'Sensores',
  },
  {
    text: 'Info Sensor',
  },
];

export const routeSensorEdit = [
  {
    route: SENSOR_PATH,
    text: 'Sensores',
  },
  {
    text: 'Editar Sensor',
  },
];

export const routeGrafica = [
  {
    text: 'Gráficas',
  },
];

export const routeGraficaInfo = [
  {
    route: GRAFICA_PATH,
    text: 'Gráficas',
  },
  {
    text: 'Info Gráfica',
  },
];

export const routeGraficaCrear = [
  {
    route: GRAFICA_PATH,
    text: 'Gráficas',
  },
  {
    text: 'Crear Gráfica',
  },
];

export const routeReporte = [
  {
    text: 'Reportes',
  },
];

export const routeLogs = [
  {
    text: 'Logs del Sistema',
  },
];
